import { useContext } from 'react';
import SidebarMenu from './SidebarMenu';
import { CloseTwoTone, School } from '@mui/icons-material';
import Scrollbar from '../../../../pages/global/Scrollbar';
import { SidebarContext } from '../../contexts/SidebarContext';
import { Box,Drawer, styled, Divider, useTheme,Tooltip, IconButton,Typography } from '@mui/material';

const SidebarWrapper = styled(Box)(
  ({ theme }) => `
      width: ${theme.sidebar.width};
      min-width: ${theme.sidebar.width};
      position: relative;
      z-index: 7;
      height: 100%;
      padding-bottom: 68px;`
  );

const LogoSection = styled(Box)(({ theme }) => ({
  padding: theme.spacing(0, 3),
  marginBottom: theme.spacing(2),
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.5),
  '& .logo-icon': {
    background: 'linear-gradient(135deg, #f84a00 0%, #894325 100%)',
    borderRadius: '12px',
    padding: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }
}));

const LogoText = styled(Typography)(() => ({
  fontWeight: 700,
  fontSize: '1.5rem',
  display: 'flex',
  alignItems: 'center',
  gap: '2px',
  whiteSpace: 'nowrap',
}));

const EthioText = styled('span')(() => ({
  color: '#ff5d1a',
}));

const LiqText = styled('span')(() => ({
  color: '#ffffff',
  position: 'relative',
  display: 'inline-block',
  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: '-4px',
    left: 0,
    right: 0,
    height: '3px',
    background: 'linear-gradient(90deg, transparent, #ff5d1a, transparent)',
    borderRadius: '2px',
  }
}));

function Sidebar() {
  const theme = useTheme();
  const closeSidebar = () => toggleSidebar();
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);

  return (
    <>
    <Drawer variant="persistent" anchor="left" open={sidebarToggle} onClose={closeSidebar}
        sx={{ width: `${theme.sidebar.width}`, flexShrink: 0, display: { xs: 'inline-block', lg: 'inline-block'},
          '& .MuiDrawer-paper': { width: `${theme.sidebar.width}`,  backgroundColor:'customPrimary.main' , boxSizing: 'border-box', overflow: 'auto', }  }}>
      <SidebarWrapper sx={{ position: 'fixed', left: 0,top: 0,  }} >
        <Box component="span" sx={{ mt: 1, mr: 1, display:'flex', alignItems:"center", justifyContent:'space-between'}} >
            <LogoSection>
              <Box className="logo-icon">
                <School sx={{ color: '#FFFFFF', fontSize: 24 }} />
              </Box>
                <LogoText>
                  <EthioText>ETHIO</EthioText>
                  <LiqText>Liq</LiqText>
                </LogoText>
            </LogoSection>


            {sidebarToggle ? (
              <Tooltip arrow title="Close Menu">
                <IconButton sx={{ color:'white' }} onClick={toggleSidebar}>
                  <CloseTwoTone fontSize="small" />
                </IconButton>
              </Tooltip>
              ) : (null)
            }
        </Box>
        <Scrollbar>
          <Divider sx={{ mx: theme.spacing(2)}} />
          <SidebarMenu />
        </Scrollbar>
        <Divider/>
      </SidebarWrapper>
    </Drawer>
    </>
  );
}
export default Sidebar;